// extracted by mini-css-extract-plugin
export default {"container":"contacts_container__Dzkxv","columnTitle":"contacts_columnTitle__Zc-5B"};